import { render, staticRenderFns } from "./list-pendaftaran.vue?vue&type=template&id=5c0f8399&"
import script from "./list-pendaftaran.vue?vue&type=script&lang=js&"
export * from "./list-pendaftaran.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports